import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { withRouter, Link } from 'react-router-dom';
import classNames from 'classnames';

import { getUser } from '../../actions/authentication';

import AppBar from '../base/AppBar/AppBar';
import AppMenu from '../AppMenu/AppMenu';
import SelectLanguage from '../SelectLanguage/SelectLanguage';
import Toolbar from '../base/Toolbar/Toolbar';

import { fixedRoutes } from './constants';
import { getLogo } from '../../utils/logo';
import { rootUrl, logoutPath, authErrorPath } from '../../constants/urls';

const styles = theme => ({
  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  appBar: {
    position: 'static',
    maxWidth: '100vw',
  },
  fixed: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    boxShadow: 'none',
  },
  header: {
    backgroundColor: theme.palette.primary.main,
    height: 72,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',

    [theme.breakpoints.up('sm')]: {
      padding: `0 ${theme.spacing(4)}px`,
    },
  },
  title: {
    textTransform: 'uppercase',
  },
  logo: {
    maxHeight: 50,
    maxWidth: 100,
  },
});

const storageListener = () => {
  const userId = this.props.user && this.props.user.id;
  const newUser = JSON.parse(localStorage.getItem('user'));

  if (userId && newUser && userId !== newUser.id) {
    window.location.reload()
  }
};

class Header extends Component {
  componentDidMount() {
    const { history, location: { pathname, search } } = this.props;

    if (!([logoutPath(), authErrorPath()].includes(pathname))) this.props.actions.getUser();

    if (window) {
      window.addEventListener('storage', storageListener)
    }

    if (search.includes('?token=')) {
      history.replace(pathname);
    }
  }

  componentWillUnmount() {
    if (window) window.removeEventListener('storage', storageListener);
  }

  render() {
    const { classes: c, location: { pathname }, user } = this.props;
    const isFixed = fixedRoutes.find(route => pathname.startsWith(route));

    if ([logoutPath(), authErrorPath()].includes(pathname)) return null;

    return (
      <AppBar
        position={isFixed ? 'fixed' : 'static'}
        className={classNames(c.appBar, isFixed && c.fixed)}
      >
        <Toolbar className={c.header}>
          <Link className={c.flexCenter} to={rootUrl()} >
            <img src={getLogo()} alt='Company logo' className={c.logo} />
          </Link>
          <div className={c.flexCenter}>
            {user && <SelectLanguage user={user} />}
            {user && <AppMenu user={user} />}
          </div>
        </Toolbar>
      </AppBar>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
});

const mapDispatchToProps = dispatch => ({
  actions: {
    getUser: bindActionCreators(getUser, dispatch),
  },
})

export default withRouter(withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Header)));



// WEBPACK FOOTER //
// ./src/components/Header/Header.js